import uiCommonActions from '@/store/ui/common/actions'

const actions = { ...uiCommonActions }

export default actions
